import utils from '@utils';

/**
 * CSVエクスポート
 * @param qp チームID
 */

export const exportUsers = async (qp: UsersCsvDownload) => {
  const res = await utils.axios.slsGo().get('/users_csv', {params: qp});

  return res;
};

/**
 * CSVインポート
 * @param b 対象のファイル
 */

export const importUsers = async (b: UsersCsvUploadBody) => {
  const res = await utils.axios.slsGo().post('/users_csv', b);

  return res;
};
